import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angularjs';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-ac-report-layouts',
  templateUrl: './ac-report-layouts.component.html',
  styleUrls: ['./ac-report-layouts.component.css']
})
export class AcReportLayoutsComponent implements OnInit {
    public itemsListReportLayouts: Item[] = [];

    constructor(private state: StateService, private datatask: DataTaskService) { }

    private async loadAcReportLayouts(): Promise<void> {
        this.itemsListReportLayouts = await this.datatask.Post(2801, { res: 'a' });
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'acreportlayout':
                this.state?.go('acreportlayout', { acreportlayout_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadAcReportLayouts();
    }

    ngOnInit() {
        this.init();
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReportLayouts', {
//        templateUrl: 'views/components/views/acReportLayouts/acReportLayouts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'accountingPlService', function (stateService, accountingPlService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListReportLayouts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadAcReportLayouts() {
//                vm.model.itemsListReportLayouts = await accountingPlService.listAcReportLayouts({ res: 'a' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'acreportlayout':
//                        go({ acreportlayout_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadAcReportLayouts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
